import React, { ReactNode } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

interface PrivateRouteProps {
  children?: ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { hasAuthenticated } = useAuth();


  if (hasAuthenticated) {
    return <><Outlet /></>;
  } else {
    return <Navigate to="/" />;
  }
};

export default PrivateRoute;
